export const propertyTypeOptions = [
  { label: "Default", value: null },
  { label: "Single family", value: "single_family" },
  { label: "Multi family", value: "multi_family" },
  { label: "Manufactured housing", value: "manufactured_housing" }
];

export const blankUnit = {
  title: "",
  monthly_rent_amount: null,
  home_rent_amount: null,
  site_rent_amount: null,
  occupied: false,
  available_at: new Date().toISOString().split("T")[0],
  external_id: ""
};
